/** Canonical Task 17 forensic-recovery hook retained at the historical import path. */

import {
  useForensicRecoveryChooser,
  type UseForensicRecoveryChooserResult,
} from "@/lib/use-forensic-recovery-chooser";

export type UseForensicPauseLiftResult = UseForensicRecoveryChooserResult;

/** The ignored argument preserves caller compatibility without starting a legacy query rail. */
export function useForensicPauseLift(_legacyAlertFact?: boolean): UseForensicPauseLiftResult {
  return useForensicRecoveryChooser();
}
